import React, { useState } from 'react';

// Ojo con el z-index: va en z-40 y no en z-50 a proposito.
//
// Los modales de la app usan z-50, y como este boton se monta despues en
// el DOM ganaba el empate y les tapaba los botones de abajo. En el
// asistente de recetas dejaba el "Continuar" imposible de apretar en
// pantallas angostas: el anillo pulsante se comia el clic.
//
// En el celular del profesional este botón no se ve: Soporte está en el "Más"
// de la barra de abajo (BarraProfesional), que usa este mismo link.
const phoneNumber = '5493794080538'; // Tu número de WhatsApp
const message = 'Hola, necesito ayuda con ConsultAR';
export const SOPORTE_WHATSAPP_URL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

const WhatsAppButton: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const whatsappUrl = SOPORTE_WHATSAPP_URL;

  return (
    <>
      {/* Botón flotante */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        // `fab-soporte`: la landing del profesional la sube en el celular para
        // que no tape la barra fija de "Agendar Cita" (regla en index.css).
        className="fab-soporte fixed bottom-6 right-6 z-40 group"
        aria-label="Contactar por WhatsApp"
      >
        {/* Badge de "Soporte" */}
        <div 
          className={`absolute -top-2 -left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full shadow-lg transition-all duration-300 z-10 ${
            isHovered ? 'scale-110' : 'scale-100'
          }`}
        >
          Soporte
        </div>

        {/* Círculo principal */}
        <div 
          className={`w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 ${
            isHovered ? 'scale-110 shadow-green-500/50' : 'scale-100'
          }`}
        >
          {/* Ícono de WhatsApp */}
          <svg 
            className="w-9 h-9 text-white" 
            fill="currentColor" 
            viewBox="0 0 24 24"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </div>

        {/* Animación de pulso */}
        <div className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-20"></div>
        
        {/* Tooltip al hacer hover */}
        <div 
          className={`absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium shadow-xl transition-all duration-300 ${
            isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-2 pointer-events-none'
          }`}
        >
          ¿Necesitás ayuda? Hablemos
          {/* Flecha del tooltip */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
            <div className="w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-gray-900"></div>
          </div>
        </div>
      </a>
    </>
  );
};

export default WhatsAppButton;